<div class="d-flex flex-column align-items-center my-5 text-center">
  <h1>Aucun chantier affecté</h1>
  <p>Vous n'avez aucun chantier affecté à votre utilisateur. Contactez votre administrateur.</p>
</div>

